import QueryLunchOptions from "graphql/queries/QueryLunchOptions";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchLunchOption
{
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'lunch_options', QueryLunchOptions, {
			resultPath: [ 'lunch_options' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}
